import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
/**
 * 环境检测结果接口
 */
export interface EnvironmentDetectionResult {
  /** 是否为微信浏览器 */
  isWeChatBrowser: boolean;
  /** 是否为微信小程序 */
  isWXMP: boolean;
  /** 是否为支付宝浏览器 */
  isAliPayBrowser: boolean;
  /** 是否为yiyou域名 */
  isYinlibo: boolean;
  /** 当前域名 */
  currentDomain: string;
  /** 用户代理字符串 */
  userAgent: string;
  /** 是否为本地模式 */
  isLocal: boolean;
}

/**
 * 环境检测服务
 * 用于检测当前运行环境，包括浏览器类型和域名信息
 */
@Injectable({
  providedIn: 'root',
})
export class EnvironmentDetectorService {
  document = inject(DOCUMENT);
  /**
   * 检测当前环境
   * @returns 环境检测结果
   */
  detectEnvironment(): EnvironmentDetectionResult {
    const userAgent = navigator.userAgent.toLowerCase();
    const currentDomain = this.document.location.hostname.toLowerCase();

    return {
      isWeChatBrowser: this.isWeChatBrowser(userAgent),
      isWXMP: this.isWXMP(userAgent),
      isAliPayBrowser: this.isAliPayBrowser(userAgent),
      isYinlibo: this.isYinliboDomain(currentDomain),
      isLocal: this.isLocal(currentDomain),
      currentDomain,
      userAgent,
    };
  }

  private isWXMP(userAgent: string): boolean {
    // 检测微信小程序的多种标识
    if (/micromessenger/i.test(userAgent) && (/miniProgram/i.test(userAgent) || (window as any)?.__wxjs_environment === 'miniprogram')) {
      return true;
    }
    return false;
  }

  /**
   * 检测是否为微信环境
   * @param userAgent 用户代理字符串
   * @returns 是否为微信环境 包括小程序和浏览器
   */
  private isWeChatBrowser(userAgent: string): boolean {
    // 检测微信浏览器的多种标识
    const wechatPatterns = [
      /micromessenger/i, // 标准微信浏览器标识
      // /wechat/i, // 微信标识
      // /wxwork/i, // 企业微信标识
    ];

    // 检查是否匹配任何微信浏览器模式
    const isWeChat = wechatPatterns.some((pattern) => pattern.test(userAgent));

    return isWeChat;
  }
  private isAliPayBrowser(userAgent: string): boolean {
    // 检测支付宝浏览器的多种标识
    const aliPayPatterns = [/AlipayClient/i, /AliApp/i];

    // 检查是否匹配任何支付宝浏览器模式
    const isAliPay = aliPayPatterns.some((pattern) => pattern.test(userAgent));

    return isAliPay;
  }

  /**
   * 检测是否为yinlibo域名
   * @param domain 域名
   * @returns 是否为yinlibo域名
   */
  private isYinliboDomain(domain: string): boolean {
    // 检测域名中是否包含 'yinlibo'
    return domain.includes('yinlibovip.com');
  }

  private isLocal(domain: string): boolean {
    return domain.includes('192.168.2') || domain.includes('localhost');
  }
}
